export function lookupCategory(categoryname) {
  let category = {}

  switch (categoryname) {
    case 'Domestic Equity':
      category = { name: 'domestic-equity', order: 1 }
      break
    case 'International Equity':
    case 'Global/International Equity':
      category = { name: 'international-equity', order: 2 }
      break
    case 'Sector Equity/Specialty':
      category = { name: 'sector-equity', order: 3 }
      break
    case 'Asset Allocation/Alternative':
    case 'Asset Allocation':
      category = { name: 'asset-allocation', order: 4 }
      break
    case 'Alternative':
      category = { name: 'alternative', order: 5 }
      break
    case 'Taxable Fixed Income':
      category = { name: 'taxable-fixed-income', order: 6 }
      break
    case 'Tax-Exempt Fixed Income':
      category = { name: 'tax-exempt-fixed-income', order: 7 }
      break
    case 'Money Market':
      category = { name: 'money-market', order: 8 }
      break
    default:
      category
  }

  return category
}
